import React from 'react';

class Null extends React.Component {

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
        const style = {
            color: "#A4A4A4"
        }        

		if (!this.props.value)
			return <React.Fragment ><div style={style}>{"None"}</div></React.Fragment>
        
        return <React.Fragment>{this.props.value}</React.Fragment>
	}
}

export default Null;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/Null.js